// Packages
import { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { FormGroup } from "reactstrap";
import moment from "moment";

// import DatePicker from "react-datepicker";
import eventadded from "../../assets/images/eventadded.svg";
// Styles
import { get, map, size } from "lodash";

// Utils
import { getFromLocalStorage } from "../../utils/webStorage";

// All Urls

// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";
import ElevationScroll from "./ElevationScroll";
import { CircularProgress, Input } from "@material-ui/core";

// import "react-datepicker/dist/react-datepicker.css";
// import schoolAdminDashboard from "./schoolAdminPortal/schoolAdminDashboard"
// Styles
import "./schoolAdmin.css";

// Assets
import backarrow from "../../assets/images/back-arrow.png";

// Material Ui
import Toolbar from "@material-ui/core/Toolbar";
import Container from "@material-ui/core/Container";
//Utils

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";

// Services
import userService from "../../services/user.service";
import { connect } from "react-redux";
import PageNotFound from "../../routes/PageNotFound";
import { userRoles } from "../../utils/constant";
import PageNotFoundPage from "../../Common/PageNotFoundPage";

class EditEvents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      countryList: [],
      schoolTypeList: [],
      teamsDropdownData: [],
      schoolId: null,
      selectedCOuntry: "",
      countryId: null,
      stateid: "",
      eventDate: "",
      eventDescription: "",
      eventName: "",
      eventTime: "",
      location: "",
      team1Id: "",
      team2Id: "",
      eventType: "",
      anyMessage: "",
      specialty: "",
      selectedFile: null,
      fileAddress: null,
      uploadId: null,
      imagePreviewUrl: "",
      team1Name: "",
      team2Name: "",
      eventId: null,
      submitting: false,
      team1Score: null,
      team2Score: null,
      startDate: new Date(),
      disabled: false,
      schoolName: "",
      showFlag: false,
      schoolList: [],
      newTeamName: "",
    };
    this.registerSchoolAdmin = this.registerSchoolAdmin.bind(this);
    this.fetchEventId = this.fetchEventId.bind(this);
  }
  //datepicker
  handleChange(date) {
    this.setState({
      startDate: date,
    });
  }

  // for popup
  openDialog() {
    this.setState({ open: !this.state.open });
  }

  closeDialog() {
    this.setState({ open: !this.state.open });
  }

  openDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }
  closeDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }
  openDialogeventupdate() {
    this.setState({ openevent: !this.state.openevent });
  }
  closeDialogeventupdate() {
    this.setState({ openevent: !this.state.openevent });
  }

  //end pop up

  componentDidMount() {
    this.setState({
      submitting: true,
    });
    const coach = document.getElementById("Event");
    if (coach) {
      coach.classList.add("btnActive");
    }
    const schoolId = getFromLocalStorage("schoolId");
    const schoolName = getFromLocalStorage("schoolName");
    this.setState({ schoolId });
    this.fetchEventId();
    this.getTeamDropdownData(schoolId);
    const fetchSchoolList = this.getSchoolList();
    fetchSchoolList.then((res) => {
      const schoolList = res.data.data.schools;
      const filteredSchoolList = schoolList.filter((item) => {
        return item.schoolName !== schoolName;
      });
      this.getEditEventData(filteredSchoolList);
      this.setState({ schoolList: filteredSchoolList });
    });

    this.setState({
      submitting: false,
      schoolName,
    });
  }

  fetchEventId() {
    const eventId = this.props.match.params.eventId;
    this.id = eventId;
    this.setState({ eventId });
  }

  getTeamDropdownData(id) {
    this.setState({
      submitting: true,
    });
    userService
      .getTeamsDropdown(id)
      .then((response) => {
        var teamsDropdownData = response.data.data.teams;
        this.setState({ teamsDropdownData });
        this.setState({
          submitting: false,
        });
      })
      .catch((error) => {
        this.setState({
          submitting: false,
        });
        console.error("There was an error!", error);
      });
  }

  getSchoolList = () => {
    return userService.getAllSchoolListing();
  };

  setOtherTeamName = (school2Name) => {
    this.setState({ showFlag: true, newTeamName: school2Name });
  };

  getEditEventData = (schoolList) => {
    this.setState({
      submitting: true,
    });
    userService
      .getEventDetailsEdit(this.id)
      .then((response) => {
        const {
          eventDate,
          eventDescription,
          eventName,
          eventTime,
          location,
          eventType,
          school2Name,
        } = response.data.data;

        const schoolNames = schoolList.map((item) => item.schoolName);

        this.setState({
          eventDate,
          eventDescription,
          eventName,
          eventTime,
          location,
          eventType,
          team2Name: school2Name,
        });
        schoolNames.includes(school2Name)
          ? this.setState({ showFlag: false })
          : this.setOtherTeamName(school2Name);

        this.state.eventType = response.data.data.eventType;
        if (response.data.data.team1 != null) {
          this.state.team1Id = response.data.data.team1.id;
          this.state.team1Name = response.data.data.team1.teamName;
        }
        if (response.data.data.team2 != null) {
          this.state.team2Id = response.data.data.team2.id;
          this.state.team2Name = response.data.data.team2.teamName;
        }
        this.setState({
          submitting: false,
        });
      })
      .catch((error) => {
        this.setState({
          submitting: false,
        });
        console.error("There was an error!", error);
      });
  };

  validateNo() {
    const { phoneNumber } = this.state;
    let errors = {};
    let formIsValid = true;
    if (phoneNumber !== "undefined") {
      var patternone = new RegExp(
        /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/
      );

      if (!patternone.test(phoneNumber)) {
        formIsValid = false;
        errors["mobileno"] = "Please enter only number.";
      } else if (phoneNumber.length !== 10) {
        formIsValid = false;
        errors["mobileno"] = "Please enter valid phone number.";
      }
    }

    this.setState({
      errors: errors,
    });
    return formIsValid;
  }

  getSpecialityList() {
    this.setState({
      submitting: true,
    });
    userService
      .getSpecialtyDropdown()
      .then((response) => {
        var schoolTypeList = response.data.data;
        this.setState({ schoolTypeList });
        this.setState({
          submitting: false,
        });
      })
      .catch((error) => {
        this.setState({
          submitting: false,
        });
        console.error("There was an error!", error);
      });
  }

  handleRadioChange = (event) => {
    this.setState({ eventType: event.target.value });
  };
  //datepicker
  ondateSet = (date) => {
    var dateSend = moment(date).format("YYYY-MM-DD");
    this.setState({
      eventDate: dateSend,
      startDate: date,
    });
  };

  registerSchoolAdmin(e) {
    this.setState({
      submitting: true,
      disabled: true,
    });
    e.preventDefault();
    const {
      eventName,
      eventType,
      eventDate,
      eventTime,
      location,
      eventDescription,
      eventId,
      team1Id,
      team2Id,
      schoolId,
      team1Score,
      team2Score,
    } = this.state;
    const { history } = this.props;
    userService
      .EventEdit(
        eventDate,
        eventDescription,
        eventName,
        eventTime,
        eventType,
        location,
        team1Id,
        team2Id,
        eventId,
        schoolId,
        team1Score,
        team2Score
      )
      .then((response) => {
        this.setState({
          disabled: false,
        });
        if (response.status === 200) {
          this.openDialogeventupdate();
        } else {
          alert("Something went wrong");
        }
        this.setState({
          submitting: false,
        });
      })
      .catch((error) => {
        this.setState({
          submitting: false,
          disabled: false,
        });
        console.error("There was an error!", error);
      });
    // }
  }

  render() {
    const {
      open,
      location,
      team1Id,
      team1Name,
      team2Name,
      eventName,
      team2Id,
      eventType,
      eventDate,
      eventTime,
      eventDescription,
      teamsDropdownData,
      errors,
      disabled,
      schoolName,
      imageUploadText,
      submitting,
      lastName,
      startDate,
      showFlag,
      schoolList,
      newTeamName,
    } = this.state;

    const { userRole } = this.props;

    return (
      <div>
        {userRole !== userRoles.ROLE_ATHLETE ? (
          <div className={submitting ? "gray-out" : " "}>
            <SchoolAdminDashboard />
            <div className="content-layout add-sectionn p-0">
              <>
                <Toolbar className="tb-p">
                  <div className="mng-header stickyy">
                    <div>
                      <Link to="/schoolevents">
                        <span className="backbtn">
                          <img src={backarrow} alt="back"></img>
                        </span>
                      </Link>
                      <span className="txt-blue bold fs-18"></span>{" "}
                      <span className="txt-blue bold fs-18 mg-left resp-headig">
                        {schoolName} VS {team2Name} {lastName}
                      </span>
                    </div>
                  </div>
                </Toolbar>
                {submitting && (
                  <CircularProgress
                    style={{
                      width: "45px",
                      height: "44px",
                      position: "absolute",
                      left: "50%",
                      top: "50%",
                      zIndex: "99",
                    }}
                    color="secondary"
                  />
                )}
                <Container>
                  <form name="adminRegistrationForm">
                    <div className="col-lg-7 col-12 col-sm-12">
                      <div className="white-card">
                        <div className="row">
                          <div className="mt-12 col-md-12 col-lg-12">
                            <div className="row">
                              <div className="col-5 col-md-5 col-lg-5">
                                <div class="form-group">
                                  <input
                                    className="form-control regular"
                                    name="specialty"
                                    value={schoolName}
                                    disabled
                                  />

                                  <div className="errorMsg fs-14 medium">
                                    {errors.team1Id}
                                  </div>
                                </div>
                              </div>
                              <div className="col-2 col-md-2 col-lg-2 d-flex h50 align-items-center justify-content-center">
                                <label className="fs-18 regular pt-3 vs-label">
                                  VS
                                </label>
                              </div>
                              <div className="col-5 col-md-5 col-lg-5">
                                <div class="form-group">
                                  <select
                                    className="instn fs-16 regular w-100 olnone share-popup-input fmlabel specialselect"
                                    name="teamName"
                                  >
                                    <option value="">Select Team</option>
                                    {schoolList &&
                                      schoolList.map((item) => (
                                        <option
                                          selected={
                                            item.schoolName == team2Name
                                          }
                                        >
                                          {item.schoolName}
                                        </option>
                                      ))}
                                    <option value="null" selected={showFlag}>
                                      Others
                                    </option>
                                  </select>
                                  {showFlag && (
                                    <div className="">
                                      <input
                                        placeholder="Enter New Team"
                                        type="text"
                                        className="form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel newEvent"
                                        name="newTeamName"
                                        value={newTeamName}
                                        disabled
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="clear20"></div>
                      <div className="white-card">
                        <div className="row fs-18 ">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="row">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <FormGroup>
                                  <label className="fmlabel mt-6 semi-bold ">
                                    Event Name{" "}
                                    <span className="redstar">*</span>
                                  </label>
                                  <input
                                    className="form-control regular"
                                    type="text"
                                    name="eventName"
                                    id="eventName"
                                    value={eventName}
                                    onChange={(e) => {
                                      this.setState({
                                        eventName: e.target.value,
                                      });
                                    }}
                                    placeholder="Enter Event Name"
                                    disabled={true}
                                  ></input>
                                </FormGroup>
                              </div>
                            </div>
                            <div className="clear10"></div>
                            <div className="row">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <FormGroup>
                                  <label className="fmlabel mt-6 semi-bold ">
                                    Event Type{" "}
                                    <span className="redstar">*</span>
                                  </label>
                                  <div className="row">
                                    <div className="col-4 col-md-4 col-lg-4">
                                      <input
                                        type="radio"
                                        id="html"
                                        name="fav_language"
                                        checked={eventType == "Game"}
                                        value="Game"
                                        onChange={this.handleRadioChange}
                                        disabled
                                      />
                                      <label
                                        className="fmlabel mt-6 semi-bold"
                                        for="html"
                                      >
                                        &nbsp;Game
                                      </label>
                                    </div>
                                    <div className="col-4 col-md-4 col-lg-4">
                                      <input
                                        type="radio"
                                        id="css"
                                        name="fav_language"
                                        checked={eventType == "Practices"}
                                        value="Practices"
                                        onChange={this.handleRadioChange}
                                        disabled
                                      />
                                      <label
                                        className="fmlabel mt-6 semi-bold"
                                        for="css"
                                      >
                                        &nbsp;Practices
                                      </label>
                                    </div>
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-4">
                                      <input
                                        type="radio"
                                        id="javascript"
                                        name="fav_language"
                                        checked={eventType == "Scout"}
                                        value="Scout"
                                        onChange={this.handleRadioChange}
                                        disabled
                                      />
                                      <label
                                        className="fmlabel mt-6 semi-bold"
                                        for="javascript"
                                      >
                                        &nbsp;Scout
                                      </label>
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                                <FormGroup>
                                  <label className="fmlabel mt-6 semi-bold ">
                                    Event Date{" "}
                                    <span className="redstar">*</span>
                                  </label>
                                  <DatePicker
                                    className="form-control regular dateStyle cp"
                                    selected={startDate}
                                    onChange={(date) => this.ondateSet(date)}
                                    name="startDate"
                                    dateFormat="MM/dd/yyyy"
                                    minDate={new Date()}
                                    disabled
                                  />
                                  <div className="errorMsg fs-14 medium">
                                    {errors.eventDate}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-12 col-sm-6 col-md-6 col-lg-6 pl-1">
                                <FormGroup>
                                  <label className="fmlabel mt-6 semi-bold">
                                    Event Time{" "}
                                    <span className="redstar">*</span>
                                  </label>
                                  <input
                                    type="time"
                                    className="form-control regular"
                                    name="eventTime"
                                    value={eventTime}
                                    onChange={(e) => {
                                      this.setState({
                                        eventTime: e.target.value,
                                      });
                                    }}
                                    disabled
                                    placeholder="Enter Event Time"
                                  ></input>
                                  <div className="errorMsg fs-14 medium"></div>
                                </FormGroup>
                              </div>
                            </div>
                            <div className="clear10"></div>
                            <div className="row">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <FormGroup>
                                  <label className="fmlabel mt-6 semi-bold">
                                    Location <span className="redstar">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control regular"
                                    name="location"
                                    value={location}
                                    onChange={(e) => {
                                      this.setState({
                                        location: e.target.value,
                                      });
                                    }}
                                    disabled
                                    placeholder="Enter Location"
                                  ></input>
                                  <div className="errorMsg fs-14 medium"></div>
                                </FormGroup>
                              </div>
                            </div>
                            <div className="clear10"></div>
                            <div className="row">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <FormGroup>
                                  <label className="fmlabel mt-6 semi-bold">
                                    Event Description{" "}
                                    <span className="redstar">*</span>
                                  </label>

                                  <textarea
                                    class="form-control fs-18 regular"
                                    rows="5"
                                    id="comment"
                                    placeholder="Enter Description"
                                    value={eventDescription}
                                    onChange={(e) => {
                                      this.setState({
                                        eventDescription: e.target.value,
                                      });
                                    }}
                                    disabled
                                  ></textarea>
                                  <div className="errorMsg fs-14 medium">
                                    {get(errors, "eventDescription", "")}
                                  </div>
                                </FormGroup>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="clear20"></div>
                      <div className="clear20"></div>
                    </div>
                  </form>
                  <div className="clear40"></div>
                </Container>
              </>
            </div>
          </div>
        ) : (
          <PageNotFoundPage />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userRole: state.loggedInUser.role,
  };
};

export default withRouter(connect(mapStateToProps)(EditEvents));
